module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mu-sub-header",
    class: {
      'inset': _vm.inset
    }
  }, [_vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-69327bb6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/muse-ui/src/subHeader/subHeader.vue
// module id = 451
// module chunks = 1